export enum CardSize {
  Small,
  Big,
}
